import {Component, Input, OnInit} from "@angular/core";
import {Tag, TagType} from "@models";
import {SimTaggingService} from "@services";
import {MatChip, MatChipSet} from "@angular/material/chips";

@Component({
	selector: "sim-tags-chip-view, sim-app-tags-chip-view",
	templateUrl: "./sim-tags-chip-view.component.html",
	styleUrls: ["./sim-tags-chip-view.component.scss"],
	imports: [MatChipSet, MatChip],
})
export class SimTagsChipViewComponent implements OnInit {
	@Input() allTags?: Tag[];
	@Input({required: true}) tagIds!: string[];
	@Input({required: true}) tagType!: TagType;

	protected currentTags: Tag[] = [];

	constructor(private _simTaggingService: SimTaggingService) {}

	ngOnInit(): void {
		if (!this.allTags) {
			this._simTaggingService
				.getAllTagsOfTagType(this.tagType)
				.then((allTags) => (this.allTags = allTags))
				.then(() => this._initCurrentTags());
		} else {
			this._initCurrentTags();
		}
	}

	private _initCurrentTags() {
		this.currentTags = this.allTags!.filter((tag) => this.tagIds.includes(tag.id));
	}
}
